/**
 * What the "Which of our products" card says about itself (CU-869fe6mf4).
 *
 * Pure, so the sentence is tested without mounting anything. The card
 * scopes a strategy to our own rate-card faces by tariff type and
 * insurance; when either axis is set, a caption under the fields names
 * the scope and says where the faces it leaves out will show up. It
 * is a consequence of a correct choice, not an error, so it is a
 * caption and never an Alert (UX decision 8).
 *
 * The names come from the axis catalogue — `prepaidName(bool)`,
 * `insuranceName(id)` — never from literals: the catalogue is tenant
 * data and `copy.md` forbids hardcoding an insurance name.
 */

const idOf = (item) => (typeof item === 'object' && item !== null ? item.value : item)

/**
 * `'Prepaid · Zero excess'` for what the form holds, or `null` when
 * neither axis narrows anything — the caption has nothing to say then.
 *
 * `tariffTypes` is the wire list (`['1']` / `['0']` / `[]`);
 * `insurances` is whatever the picker holds, ids or `{value, label}`.
 * An exclusion reads "all insurance except …", which is the only way
 * the sentence stays true of what the engine will do.
 */
export function faceScopeSummary({ tariffTypes, insurances, insurancesExclusion }, names) {
	const tariff = (tariffTypes || []).length === 1 ? String(tariffTypes[0]) : ''
	const ids = (insurances || []).map(idOf).filter(v => v !== null && v !== undefined && v !== '')
	const parts = []
	if (tariff === '1' || tariff === '0') parts.push(names.prepaidName(tariff === '1'))
	if (ids.length) {
		const list = ids.map(id => names.insuranceName(id)).join(', ')
		parts.push(insurancesExclusion ? `all insurance except ${list}` : list)
	}
	return parts.length ? parts.join(' · ') : null
}
